'use strict';

var defaultTheme = require('./defaultTheme-ea44e34a.js');
var lodash = require('lodash');
var React = require('react');
var Tab = require('./Tab-f499ecbc.js');
var styled = require('styled-components');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
var Tabs$1 = styled__default['default'].div.attrs(defaultTheme.applyDefaultTheme)(_templateObject || (_templateObject = defaultTheme._taggedTemplateLiteral(["\n  display: block;\n  position: relative;\n  ", ";\n"])), function (props) {
  return props.backgroundColor && styled.css(_templateObject2 || (_templateObject2 = defaultTheme._taggedTemplateLiteral(["\n      background-color: ", ";\n    "])), props.backgroundColor);
});
var TabHeaders = styled__default['default'].ul.attrs(defaultTheme.applyDefaultTheme)(_templateObject3 || (_templateObject3 = defaultTheme._taggedTemplateLiteral(["\n  display: flex;\n  overflow-x: auto;\n  overflow-y: hidden;\n  white-space: nowrap;\n  gap: 24px;\n  margin: 0;\n  padding: 0;\n"])));
var TabHeader = styled__default['default'].li.attrs(defaultTheme.applyDefaultTheme)(_templateObject4 || (_templateObject4 = defaultTheme._taggedTemplateLiteral(["\n  font-family: ", ";\n  text-transform: uppercase;\n  font-weight: 600;\n  font-size: 0.875rem;\n  display: flex;\n  padding-bottom: 8px;\n  letter-spacing: 0.6px;\n  cursor: pointer;\n  border-bottom: 1px solid;\n  border-color: transparent;\n  margin-bottom: 1px;\n\n  ", ";\n  &&:hover:not(:focus) {\n    ", ";\n  }\n"])), function (props) {
  return props.theme.secondaryFontFamily;
}, function (props) {
  return props.active && styled.css(_templateObject5 || (_templateObject5 = defaultTheme._taggedTemplateLiteral(["\n      ", "\n    "])), function (props) {
    return props.theme.themeProp('border-color', props.theme.getColor('gray-400'), props.theme.getColor('gray-700'));
  });
}, function (props) {
  return props.theme.themeProp('border-color', function () {
    if (props.active) {
      return props.theme.getColor('gray-400');
    } else {
      return props.theme.getColor('gray-400');
    }
  }, function () {
    if (props.active) {
      return props.theme.getColor('gray-700');
    } else {
      return props.theme.getColor('gray-700');
    }
  });
});
var TabContent = styled__default['default'].div.attrs(defaultTheme.applyDefaultTheme)(_templateObject6 || (_templateObject6 = defaultTheme._taggedTemplateLiteral(["\n  border-top: 1px solid;\n  margin-top: -2px;\n  display: block;\n  ", ";\n"])), function (props) {
  return props.theme.themeProp('border-color', props.theme.getColor('gray-600'), '#F0F2F5');
});

var Tabs = React__default['default'].forwardRef(function Tabs(_ref, forwardedRef) {
  var children = _ref.children,
      defaultMinHeight = _ref.defaultMinHeight,
      props = defaultTheme._objectWithoutProperties(_ref, ["children", "defaultMinHeight"]);

  var _useState = React.useState(0),
      _useState2 = defaultTheme._slicedToArray(_useState, 2),
      activeTab = _useState2[0],
      setActiveTab = _useState2[1];

  var _useState3 = React.useState(),
      _useState4 = defaultTheme._slicedToArray(_useState3, 2),
      defaultHeight = _useState4[0],
      setDefaultHeight = _useState4[1];

  var contentRef = React.useRef(null);
  React.useEffect(function () {
    setDefaultHeight(defaultMinHeight);
  }, []);
  var tabs = React.useMemo(function () {
    var tabs = [];

    function extractChildren(children) {
      React.Children.forEach(children, function (child, index) {
        var _child$props2;

        if (lodash.isNil(child)) {
          return null;
        }

        if (child.type === React.Fragment) {
          var _child$props;

          extractChildren((_child$props = child.props) === null || _child$props === void 0 ? void 0 : _child$props.children);
        }

        if ((_child$props2 = child.props) !== null && _child$props2 !== void 0 && _child$props2.hidden) {
          return null;
        }

        if (child.type === Tab.Tab) {
          var _child$props3, _child$props4;

          tabs.push({
            key: index,
            trigger: (_child$props3 = child.props) === null || _child$props3 === void 0 ? void 0 : _child$props3.trigger,
            content: (_child$props4 = child.props) === null || _child$props4 === void 0 ? void 0 : _child$props4.children
          });
        }
      });
    }

    extractChildren(children);

    if (!tabs.some(function (tab) {
      return (tab === null || tab === void 0 ? void 0 : tab.key) === activeTab;
    })) {
      var _tabs$;

      setActiveTab((_tabs$ = tabs[0]) === null || _tabs$ === void 0 ? void 0 : _tabs$.key);
    }

    return tabs;
  }, [children]);
  return React__default['default'].createElement(Tabs$1, defaultTheme._extends({
    ref: forwardedRef
  }, props, {
    role: "tablist"
  }), React__default['default'].createElement(TabHeaders, null, tabs.map(function (tab) {
    return React__default['default'].createElement(TabHeader, {
      key: tab.key,
      hidden: tab.hidden,
      active: tab.key === activeTab,
      onClick: function onClick() {
        return setActiveTab(tab.key);
      },
      role: "tab"
    }, tab.trigger);
  })), React__default['default'].createElement(TabContent, null, tabs.map(function (tab) {
    return React__default['default'].createElement("div", {
      ref: tab.key === (activeTab === null || activeTab === void 0 ? void 0 : activeTab.key) ? contentRef : null,
      key: tab.key,
      role: "tabpanel",
      hidden: tab.key !== activeTab,
      style: {
        minHeight: !lodash.isEmpty(defaultHeight) ? defaultHeight : ''
      }
    }, tab.content);
  })));
});
Tabs.defaultProps = {
  defaultMinHeight: ''
};
Tabs.propTypes = process.env.NODE_ENV !== "production" ? {
  children: defaultTheme.PropTypes.oneOfType([defaultTheme.PropTypes.array, defaultTheme.PropTypes.object]),
  backgroundColor: defaultTheme.PropTypes.string,
  defaultMinHeight: defaultTheme.PropTypes.string
} : {};

exports.Tabs = Tabs;
